
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import { blue } from '@material-ui/core/colors';

const BlueButtonSmall = withStyles(theme => ({
  root: {
    margin: {
      margin: theme.spacing(3),
    },
    textTransform: 'none',
    fontSize: 10,
    padding: '6px 12px',
    color: theme.palette.getContrastText(blue[500]),
    backgroundColor: blue[500],
    '&:hover': {
      backgroundColor: blue[700],
    },
  },
}))(Button);

export default BlueButtonSmall;